
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { endRubberline } from "../../../store/interaction";
import { modelSplitShapes } from "../../../store/model";
import { RootState } from "../../../store/store";
import { Segment } from "../shapes/line/Line";
import BaseLine from "../shapes/line/LineBase";
import { getShapeTransfomer, registerToolRendererGroup } from "../util/shapeCategorySingleton";
import { strokeCorrection } from "../util/strokeCorrection";
import { useSnapMousePosition } from "./useSnapMousePosition";

const SplitSymbol = () => {
  const dispatch = useAppDispatch();
  const selectionIds = useAppSelector((state: RootState) => state.model.present.selected.selectedItemIds)
  const shapes = useAppSelector((state: RootState) => state.model.present.model.shapes);
  const interaction = useAppSelector((state: RootState) => state.interaction)
  const scale = useAppSelector((state: RootState) => state.interface.viewport.scale)
  const mousePosition = useAppSelector((state: RootState) => state.interface.mouseUnmodifiedPosition);
  const defaultLineSetting = useAppSelector((state: RootState) => state.tool.toolSettings.move.symbolLine);
  const selectedShapes = shapes.filter((shape: GeometricShape) => selectionIds.find((selectionId) => shape.id === selectionId) !== undefined);
  const mousePositionSnap = useSnapMousePosition();


  // Modify Line properties for use of rotation symbol
  const internalLineProperties = {
    ...defaultLineSetting,
    id: -1,
    strokeWidth: strokeCorrection(defaultLineSetting.strokeWidth, scale),
    points: interaction.rubberlineData.snapPoints.concat(mousePositionSnap),
    draggable: false,
    closed: false,
  }

  // Points coming from clicks on the stage
  const pointBuffer = interaction.rubberlineData.snapPoints;

  switch (pointBuffer.length) {
    case 0:
      break;
    case 1: {
      return (
        <BaseLine
          shapeProps={{
            ...internalLineProperties,
            points: [pointBuffer[0], mousePositionSnap]
          }} />

      );
    }
    case 2: {


      if (selectedShapes) {
        const newShapeList: GeometricShape[] = selectedShapes.flatMap((shape) => splitShape(shape, [pointBuffer[0], mousePosition]))
        console.log("New Shape List", newShapeList);

        dispatch(modelSplitShapes(newShapeList))

        dispatch(endRubberline());
      }

      break;
    }
    default: dispatch(endRubberline())
  }
  return (
    <></>
  )
}
const createSplitSymbol = () => {
  return (
    <SplitSymbol />
  )
}
registerToolRendererGroup("split", { toolRender: createSplitSymbol })

export { createSplitSymbol };
export default SplitSymbol;

function splitShape(shape: GeometricShape, line: Segment): GeometricShape[] {
  const splitFunction = getShapeTransfomer(shape.type)?.shapeSplit;
  if (splitFunction) {
    console.log("there is a split function for ", shape);

    return splitFunction(shape, line);
  }
  return [shape];
}
